import { gql } from '@apollo/client';
import { IGroupSettings } from '_legacy/components/admin/groups/GroupSettings';
import { Divisions } from '_legacy/components/common/Divisions';

export interface GroupFragment {
    id: string;
    datasetId: number;
    division: Divisions;
    name: string;
    datasetName: string;
    createdBy: {
        username: string;
    };
    createdDate: string;
    groupOnlyExpiryPeriod: number;
    groupSettings: IGroupSettings;
}

export const GROUP_FRAGMENT = gql`
    fragment GroupFragment on GroupType {
        id
        name
        datasetId
        division
        datasetName
        createdBy {
            username
        }
        createdDate
        groupOnlyExpiryPeriod
        groupSettings {
            useDeliveryZoneForAreaMapping
            useDeliveryZoneForAreaGearedMapping
            useDeliveryZoneForAreaGearlessMapping
            useDeliveryZoneForDirectionMapping
            useHyphenSeparatorForLocations
            tankersGroupType
        }
    }
`;
